<template>
    <div>
        <card-header title='New Component' icon="fa-plus"/>

        <card-body>
            <component-form :component="component"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!component.type || !component.title"
                    ><i class="fas fa-plus mr-2"></i>New Component</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import ComponentForm from "@/cards/components/ComponentForm";

    import {client as http} from '../../http_client';
    import {v4 as uuidv4} from "uuid";

    export default {
        components: {CardHeader, CardToolbar, CardBody, CardFooter, ComponentForm},
        props: ['card'],
        data() {
            return {
                component: {
                    type: 'LESSON',
                    tags: [],
                    tagIds: [],
                    content: '{"content": [], "attributes": {}}' // JSON
                }
            }
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);

                if (this.component.type === 'LESSON') {
                    this.component.content = `{"content": [], "attributes": {"id": "${uuidv4()}"}}`;
                } else if (this.component.type === 'QUIZ') {
                    this.component.content = `{"content": [], "attributes": {"id": "${uuidv4()}"}}`;
                } else if (this.component.type === 'SURVEY') {
                    this.component.content = `{"content": [], "attributes": {"id": "${uuidv4()}"}}`;
                } else if (this.component.type === 'CHECKPOINT') {
                    this.component.content = `{"content": {"hint": [], "answers": [], "correct": [], "question": [], "incorrect": []}, "attributes": {"id": "${uuidv4()}", "type": null}}`
                }

                http.post('components/', this.component, {force: true}).then(response => {
                    this.$reloadCard('components');
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            }
        }
    }
</script>
